const ONE_HOUR = 60 * 60 * 1000;

function getCountdownEnd() {
  const now = new Date();
  const hour = now.getHours();

  // Das 17h até à meia-noite:
  // contar até às 08h do dia seguinte
  if (hour >= 17) {
    const endTime = new Date(now);
    endTime.setDate(endTime.getDate() + 1);
    endTime.setHours(8, 0, 0, 0);

    return endTime.getTime();
  }

  // Da meia-noite até às 08h:
  // continuar a contar até às 08h
  if (hour < 8) {
    const endTime = new Date(now);
    endTime.setHours(8, 0, 0, 0);

    return endTime.getTime();
  }

  // Das 16h às 17h:
  // mostrar exatamente o tempo que falta para as 17h
  if (hour >= 16) {
    const endTime = new Date(now);
    endTime.setHours(17, 0, 0, 0);

    return endTime.getTime();
  }

  // Das 08h às 16h:
  // começar com 1 hora por sessão
  let sessionEnd = sessionStorage.getItem('countdownEnd');

  if (!sessionEnd || Number(sessionEnd) <= Date.now()) {
    sessionEnd = Date.now() + ONE_HOUR;
    sessionStorage.setItem('countdownEnd', sessionEnd);
  }

  return Number(sessionEnd);
}

let countdownEnd = getCountdownEnd();

function updateCountdown() {
  const now = new Date();
  const hour = now.getHours();

  // Horários baseados na hora real
  if (hour >= 17 || hour < 8 || hour >= 16) {
    countdownEnd = getCountdownEnd();
  }

  let timeLeft = countdownEnd - Date.now();

  if (timeLeft < 0) {
    timeLeft = 0;
  }

  const hours = Math.floor(timeLeft / (1000 * 60 * 60));
  const minutes = Math.floor(
    (timeLeft % (1000 * 60 * 60)) / (1000 * 60)
  );
  const seconds = Math.floor(
    (timeLeft % (1000 * 60)) / 1000
  );

  const countdownElement = document.getElementById('countdown');

  if (countdownElement) {
    countdownElement.textContent =
      `${hours}H ${minutes}M ${seconds}S`;
  }
}

setInterval(updateCountdown, 1000);
updateCountdown();